﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M20.5,10.5v-6a1,1,0,0,0-1-1H9.618a1,1,0,0,1-.894-.553L7.776,1.053A1,1,0,0,0,6.882.5H1.5a1,1,0,0,0-1,1v15a1,1,0,0,0,1,1h8"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M12.500 17.029 A4.529 4.529 0 1 0 21.558 17.029 A4.529 4.529 0 1 0
      12.500 17.029 Z"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M23.5 23.5L20.252 20.252"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
</svg>
